import { render, staticRenderFns } from "./HistoryOrder.vue?vue&type=template&id=b7610bc8&scoped=true&"
import script from "./HistoryOrder.vue?vue&type=script&lang=js&"
export * from "./HistoryOrder.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrder.vue?vue&type=style&index=0&id=b7610bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7610bc8",
  null
  
)

export default component.exports